import datepicker from 'components/datepicker'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import slider from 'components/slider';
import locationInfoTable from 'components/locationInfoTable'
import manageInfo from 'components/manageInfo'
import generalInfo from 'components/generalInfo'
import moment from 'moment'
import { stripTags, currencySymbol, dateFormat } from 'filters'
import carVariables from './CarVariables';
import addedButton from 'components/addedButton';
import showLessBtn from 'components/showLessBtn';
import { plusIcon,  parkingDetailsIcon, locationPinIcon, shuttleBusIcon, cancellationCalendarIcon, parkingIcon, cycleIcon,
  starRatingIcon, chevronDownIcon, chevronUpIcon, infoWarningIcon, addParkingConfirmIcon, specialConditionsDocIcon, filledCheckInput, borderCheckInput, checkIcon } from 'components/icons';

const DATE_FORMATS = {
  datetime_server: 'YYYY-MM-DD HH:mm:ss',
  datetime_server_12: 'YYYY-MM-DD hh:mm A',
  datetime_server_24: 'YYYY-MM-DD HH:mm',
  datetime_12: 'MM/DD/YYYY hh:mm A',
  datetime_24: 'MM/DD/YYYY HH:mm',
}

  const components = {
  datepicker,
  VueCtkDateTimePicker,
  slider,
  locationInfoTable,
  manageInfo,
  generalInfo,
  carVariables,
  plusIcon,
  parkingDetailsIcon,
  locationPinIcon,
  shuttleBusIcon,
  cancellationCalendarIcon,
  starRatingIcon,
  cycleIcon,
  chevronDownIcon,
  chevronUpIcon,
  infoWarningIcon,
  addParkingConfirmIcon,
  specialConditionsDocIcon,
  filledCheckInput,
  borderCheckInput,
  parkingIcon,
  showLessBtn,
  addedButton,
  checkIcon,
}

const methods = {

  getCost (comefromCreate = false) {
    // Parking quote stays separate from protection. The widget adds that price once.
    const form = { ...this.form, protection_plan_id: null }
    this.loading = true
    this.$store.dispatch('affiliateWidget.cost', form).then(() => {
      this.loading = false
      // Send result back to parent
      if (comefromCreate && this.costs && this.costs.reservation && this.costs.reservation.grand_total > 0) {
        this.sendMessageToParent('iframe_ready', {
          success: true,
          data: this.costs
        });
      }
      
    }).catch((error) => {
      this.loading = false
      // Send error back to parent
      this.sendMessageToParent('costResult', {
        success: false,
        error: error
      })
      console.log("error", error);
    })
  },

  // Send message to parent window
  sendMessageToParent(type, data) {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({
        type: type,
        data: data
      }, '*')
    }
  },

  // Handle messages from parent
  handleParentMessage(event) {
    const { type, data } = event.data

    switch (type) {
      case 'resize':
        this.resizeIframe(data)
        break
      case 'setDates':
        this.setDates(data)
        break
      case 'addSelected':
        this.handleAddClick()
        break
    }
  },

  // Resize iframe based on parent request
  resizeIframe(data) {
    if (data == null || data.height == null) {
      return
    }
    const h = data.height
    const raw = typeof h === 'number' ? h : parseFloat(String(h).replace(/px$/i, ''), 10)
    document.body.style.height = Number.isFinite(raw) ? `${Math.max(0, Math.ceil(raw))}px` : 'auto'
  },

  // Set dates from parent
  setDates(data) {
    if (data.from_date) {
      this.form.from_date = data.from_date
    }
    if (data.to_date) {
      this.form.to_date = data.to_date
    }
    // Automatically call getCost after setting dates
    this.getCost()
  },

  carsDataSemanticSnapshot (cars) {
    if (!Array.isArray(cars)) return ''
    return JSON.stringify(cars.map((c) => ({
      isUserCarInputs: c.isUserCarInputs,
      userCarMakeModelInput: (c.userCarMakeModelInput || '').trim(),
      userCarBodyTypeId: c.userCarBodyTypeId,
      selectedMake: c.selectedMake,
      selectedModel: c.selectedModel,
      selectedYear: c.selectedYear,
      selectedTrimId: c.selectedTrimId,
    })))
  },

  carsDataChanged(data){
    this.carsData = data;
    this.carsDataError = null;
    if (this.reservationData && this.reservationData.added && this._carsDataSnapshotAtAdd != null) {
      if (this.carsDataSemanticSnapshot(data) !== this._carsDataSnapshotAtAdd) {
        this.clearReservationAdded()
      }
    }
  },

  clearReservationAdded () {
    if (this.reservationData && this.reservationData.added) {
      this.$store.commit('SET_RESERVATION_DATA_ADDED', false)
      this.showParkingDetails = true;
    }
  },

  // Handle add button click
  handleAddClick() {
    let cost_data = {
      grand_total: this.totalPrice,
      sub_total: this.costs.reservation.subtotal,
      tax_total: this.costs.reservation.tax_total,
      location: this.costs.location.name,
      sold_out: this.costs.reservation.sold_out,
      number_of_days: this.costs.reservation.totals.parking.number_of_days,
      currency_code: this.costs.location.currency.code,
      channel_id: this.form.channel_id,
      protection_plan_id: this.addTripProtection && this.protectionPlan ? this.protectionPlan.id : null,
      protection_plan_price: this.addTripProtection && this.protectionPlan ? this.protectionPlan.price : 0,
      costs_token: this.costs.costs_token,
    }
    this.sendMessageToParent('booking_selected', {
      success: true,
      data: cost_data,
      form: this.form
    })
  },

  // Auto-resize iframe based on content (notifies parent via postMessage)
  _releaseDocumentHeightLock() {
    const d = document.documentElement
    const b = document.body
    b.style.minHeight = ''
    b.style.height = ''
    d.style.minHeight = ''
    d.style.height = ''
  },
  autoResize() {
    this._releaseDocumentHeightLock()
    const b = document.body
    const d = document.documentElement
    // Force reflow so scrollHeight/offsetHeight reflect the unlocked layout
    void b.offsetHeight
    const root = this.$refs.affiliateResizeRoot
    let hFloat
    if (root && root.nodeType === 1) {
      // When the parent iframe is already tall, body/documentElement `scrollHeight`
      // often matches the full viewport, not the card. Measure from the document
      // root to the bottom of the widget (border box) + bottom margin.
      const dTop = d.getBoundingClientRect().top
      const rb = root.getBoundingClientRect()
      const mBottom = parseFloat(getComputedStyle(root).marginBottom) || 0
      hFloat = Math.max(0, rb.bottom - dTop + mBottom)
    } else {
      hFloat = Math.max(
        b.scrollHeight,
        b.offsetHeight,
        d.scrollHeight,
        d.offsetHeight
      )
    }
    // Ceil to avoid 1px strip scroll from subpixel layout; +1 for rounding
    const height = Math.max(0, Math.ceil(hFloat) + 1)
    const width = Math.ceil(Math.max(
      b.scrollWidth,
      b.offsetWidth,
      d.scrollWidth,
      d.offsetWidth
    ))
    this.sendMessageToParent('resize', { height, width })
  },

  _scheduleAutoResize() {
    if (this._resizeRaf) {
      cancelAnimationFrame(this._resizeRaf)
    }
    this._resizeRaf = requestAnimationFrame(() => {
      this._resizeRaf = null
      this.autoResize()
    })
  },

  _attachResizeObserver() {
    if (!this._resizeObserver) {
      this._resizeObserver = new ResizeObserver(() => {
        this._scheduleAutoResize()
      })
    } else {
      this._resizeObserver.disconnect()
    }
    const el = this.$refs.affiliateResizeRoot
    if (el) {
      this._resizeObserver.observe(el)
    } else {
      this._resizeObserver.observe(document.body)
    }
  },
  
  extractContent(html, slice=false) {
      if (html) {
        const regex = /(style=".+?")/gm;
        let str = html.replace(regex, '');
        str = str.replaceAll('</p>', '</p><br>');
        str = str.replaceAll('</h1>', '</h1><br>');
        str = str.replaceAll('</h2>', '</h2><br>');
        str = str.replaceAll('</h3>', '</h3><br>');
        str = str.replaceAll('</h4>', '</h4><br>');
        str = str.replaceAll('</h5>', '</h5><br>');
        str = str.replaceAll('</h6>', '</h6><br>');
        str = str.replaceAll('</div>', '</div><br>');
        str = str.replaceAll('</li>', '</li><br>');
        str = str.replaceAll('</ul>', '</ul><br>');
        str = str.replaceAll('</pre>', '</pre><br>');
        str = stripTags(str, ['br', 'hr']);
        str = str.replace(/12:00\s?(AM|am|Am)/g, this.$t('Midnight'));
        return slice && str.length > 50 ? str.slice(0, 50) + '...' : str;
      }
      return '';
  },

  extractLicensePlate(license_plate) {
    if (Array.isArray(license_plate)) {
      let licensePlates = [];
      license_plate.map(value => {
        let normalizedPlate = value.trim().toUpperCase().replace(/[^a-zA-Z0-9]/g, "");
        licensePlates.push(normalizedPlate);
      });
      return licensePlates;
    } else {
      let normalizedPlate = license_plate.replace(/[^a-zA-Z0-9]/g, "");
      return normalizedPlate.toUpperCase();
    }
  },

  getValidationApiErrorMessage(axiosErrorResponse) {
    if (!axiosErrorResponse || !axiosErrorResponse.data) return null;
    const d = axiosErrorResponse.data;
    if (d.errors && typeof d.errors === 'object' && !Array.isArray(d.errors)) {
      const messages = [];
      Object.keys(d.errors).forEach((k) => {
        const v = d.errors[k];
        if (Array.isArray(v)) v.forEach((m) => messages.push(m));
        else if (typeof v === 'string') messages.push(v);
      });
      if (messages.length) {
        return messages[0];
      }
    }
    if (typeof d.message === 'string' && d.message) {
      return d.message;
    }
    return null;
  },

  onExtraFieldInput (fieldName, index) {
    const key = `extra_fields.${fieldName}.${index}`;
    if (this.extraFieldsErrors[key] !== undefined) {
      this.$delete(this.extraFieldsErrors, key);
    }
    const rErr = this.reservationData && this.reservationData.errors;
    if (rErr && typeof rErr === 'object' && !Array.isArray(rErr) && rErr[fieldName]) {
      this.$store.commit('CLEAR_RESERVATION_DATA_FIELD_ERROR', fieldName);
    }
  },

  validateInput (field, value, i) {
    const trimmed = (value == null ? '' : String(value)).trim();
    if (trimmed.length === 0) {
      this.$set(this.extraFieldsErrors, `extra_fields.${field.name}.${i}`, [this.$t('the_field_is_required', {name: field.label})]);
      return Promise.resolve();
    }
    if (field.input_type === 'license_plate') {
      const normalized = this.extractLicensePlate(trimmed);
      if (!normalized || normalized === '0') {
        this.$set(this.extraFieldsErrors, `extra_fields.${field.name}.${i}`, [this.$t('invalid_license_plate')]);
        return Promise.resolve();
      }
    }
    this.beginValidationRequest();
    const payload = field.input_type === 'license_plate'
      ? { type: field.input_type, value: this.extractLicensePlate(trimmed) }
      : { type: field.input_type, value: trimmed };
    return this.$store.dispatch('validateInput.validate', payload)
      .then((out) => {
        if (!out) return;
        if (!out.ok) {
          const errResponse = out.response;
          if (errResponse) {
            const msg = this.getValidationApiErrorMessage(errResponse) || this.$t('invalid_license_plate');
            this.$set(this.extraFieldsErrors, `extra_fields.${field.name}.${i}`, [msg]);
          } else {
            this.$set(this.extraFieldsErrors, `extra_fields.${field.name}.${i}`, [this.$t('invalid_license_plate')]);
          }
          return;
        }
        const validation = out.data;
        if (!validation || typeof validation !== 'object') {
          this.$set(this.extraFieldsErrors, `extra_fields.${field.name}.${i}`, [this.$t('invalid_license_plate')]);
          return;
        }
        if (validation.valid === false) {
          if (field.input_type === 'license_plate') {
            this.$set(this.extraFieldsErrors, `extra_fields.${field.name}.${i}`, [this.$t('ensure_your_license_plate_is_accurate')]);
          } else {
            this.$set(this.extraFieldsErrors, `extra_fields.${field.name}.${i}`, [this.$t('please_check_field', { name: field.label })]);
          }
        } else {
          this.$set(this.extraFieldsErrors, `extra_fields.${field.name}.${i}`, ['']);
        }
      })
      .finally(() => {
        this.endValidationRequest();
      });
  },

  beginValidationRequest () {
    if (this.validationInFlight === 0) {
      this.$emit('loadValidation', true);
    }
    this.validationInFlight += 1;
  },

  endValidationRequest () {
    this.validationInFlight = Math.max(0, this.validationInFlight - 1);
    if (this.validationInFlight === 0) {
      this.$emit('loadValidation', false, this.getValidationMessage());
    }
  },

  getValidationMessage () {
    for (const value of Object.values(this.extraFieldsErrors)) {
      if (Array.isArray(value) && value[0] && value.includes(this.$t('ensure_your_license_plate_is_accurate'))) {
        return this.$t('ensure_your_license_plate_is_accurate');
      }
    }
    for (const value of Object.values(this.extraFieldsErrors)) {
      if (Array.isArray(value) && value[0]) {
        return value[0];
      }
    }
    return null;
  },

  extraFieldMessage (fieldName, index) {
    const value = this.extraFieldsErrors[`extra_fields.${fieldName}.${index}`]
    if (Array.isArray(value) && value[0]) return String(value[0])
    if (typeof value === 'string' && value) return value
    return ''
  },

  reservationFieldMessage (fieldName) {
    const errors = this.reservationData && this.reservationData.errors
    if (!errors || typeof errors !== 'object' || Array.isArray(errors)) return ''
    const value = errors[fieldName]
    if (Array.isArray(value) && value[0]) return String(value[0])
    if (typeof value === 'string' && value) return value
    return ''
  },

  fieldErrorText (fieldName, index) {
    return this.reservationFieldMessage(fieldName) || this.extraFieldMessage(fieldName, index)
  },

  isPlateWarning (message) {
    return typeof message === 'string' && message.indexOf(this.$t('ensure_your_license_plate_is_accurate')) !== -1
  },

  toggleParkingDetails() {
    this.showParkingDetails = !this.showParkingDetails
    this.$nextTick(() => {
      this._scheduleAutoResize()
    })
  },

  documentClicked (event) {
    if (!$(event.target).closest('.toggle-tooltip').length) {
      this.showTooltip = false;
      $('.toggle-tooltip').removeClass('active');
    }
  },

  toggleTooltip(){
    this.showTooltip = !this.showTooltip;
  },

  handleManageEdit() {
    this.showParkingDetails = true
    this.$nextTick(() => {
      this._scheduleAutoResize()
      const el = this.$refs.requiredInformation
      if (el) {
        window.scrollTo({
          top: el.offsetTop,
          behavior: 'smooth'
        })
      }
    })
  },

  handleManageDelete() {
    this.$store.commit('SET_RESERVATION_DATA_ADDED', false)
    this.showParkingDetails = false
    this._carsDataSnapshotAtAdd = null
    this.$nextTick(() => {
      this._scheduleAutoResize()
    })
  },

  handleAddParking(){
    if((this.location.extra_fields && !_.isEmpty(this.location.extra_fields)) || this.location.car_iframe){
      this.showParkingDetails = true;
      this.$nextTick(() => {
        const el = this.$refs.requiredInformation;
        if (el) {
          window.scrollTo({
            top: el.offsetTop,
            behavior: 'smooth'
          });
        }
      });
      return;
    }
    this.handleConfirm();
  },
  mapCarData(car) {
    if (car.isUserCarInputs) {
      return {
        make_model_input: car.userCarMakeModelInput,
        body_type_id: car.userCarBodyTypeId,
        body_type_name: car.userCarBodyTypeName
      };
    } else {
      const result = {
        make: car.selectedMake,
        model: car.selectedModel,
        year: car.selectedYear,
        trim_id: car.selectedTrimId,
      };
      if (car.selectedMakeId) {
        result.make_id = car.selectedMakeId;
      }
      if (car.selectedModelId) {
        result.model_id = car.selectedModelId;
      }
  
      return result;
    }
  },

  async handleConfirm() {
    if (this.confirmInProgress) {
      return;
    }
    this.confirmInProgress = true;
    let cars_data = [];
    try {
      if (this.location.car_iframe) {
        for (const car of this.carsData) {
          if (car.isUserCarInputs) {
            if (!car.userCarMakeModelInput || car.userCarMakeModelInput.trim() === "" || !car.userCarBodyTypeId) {
              this.carsDataError = "Please enter a valid car information";
              return;
            }
          } else {
            if (!car.selectedMake || !car.selectedModel || !car.selectedYear) {
              this.carsDataError = "Please enter a valid car information";
              return;
            }
            if (car.trims.length > 0 && !car.selectedTrimId) {
              this.carsDataError = "Please enter a valid car information";
              return;
            }
          }
        }
        cars_data = this.carsData.map(this.mapCarData);
      }
      const userName = (this.form.user_name == null ? '' : String(this.form.user_name)).trim()
      const userEmail = (this.form.user_email == null ? '' : String(this.form.user_email)).trim()
      if (!userName || !userEmail) {
        this.submitError = this.$t('user_name_and_email_required')
        return
      }
      this.submitError = null
      if (!_.isEmpty(this.location.extra_fields)) {
        await Promise.all(
          this.location.extra_fields.map((field) =>
            this.validateInput(field, this.form.extra_fields[field.name][0], 0)
          )
        );
        const hasNonEmpty = Object.values(this.extraFieldsErrors).some(v => Array.isArray(v) && v[0] !== "");
        if (hasNonEmpty) {
          return;
        }
      }
      const payload = {extra_fields: this.form.extra_fields, phone: this.form.phone, reserved_by: userEmail, reserved_for: userName, cars_data: cars_data, channel_id: this.form.channel_id}
      if (this.addTripProtection && this.protectionPlan && this.protectionPlan.id) {
        payload.protection_plan_id = this.protectionPlan.id;
      }
      await this.$store.dispatch('affiliateWidget.setReservationData', payload);
    } finally {
      this.confirmInProgress = false;
    }
  }
}

export default {
  name: 'public-cost',
  components,
  methods,
  filters: {
    dateFormat,
  },
  data () {
    return {
      form: {
        from_date: this.$route.query.from_date,
        to_date: this.$route.query.to_date,
        channel_id: this.$route.query.channel_id || 31,
        airport_code: this.$route.query.airport_code || 'ATL',
        user_name: this.$route.query.user_name,
        user_email: this.$route.query.user_email,
        type: this.$route.query.type || "parking",
        phone: this.$route.query.phone,
        number_of_spots: 1,
        extra_fields: {},
        location_id: null,
        protection_plan_id: null
      },
      loading: false,
      validationInFlight: 0,
      confirmInProgress: false,
      showParkingDetails: false,
      currencySymbol,
      extraFieldsErrors: {},
      carsDataError: null,
      carsData:[
        {
          isUserCarInputs: false,
          userCarMakeModelInput: "",
          userCarBodyTypeId: null,
          userCarBodyTypeName: null,
          loading:false,
          selectedMake: null,
          selectedModel: null,
          selectedYear: null,
          selectedTrimId: null,  
          models: [],
          years: [],
          trims: [],
        }
      ],
      protectionPlan: null,
      showProtectionPlans: false,
      addTripProtection: false,
      submitError: null,
      _protectionChoiceMade: false,
      showTooltip: false,
      _carsDataSnapshotAtAdd: null,
    }
  },
  created() {
    //
    if (!isServer) {

    }

  },
  mounted() {

    //http://localhost:8080/affiliate-widget?channel_id=31&airport_code=ATL&from_date=2026-11-20%2015%3A00%3A00&to_date=2026-11-25%2015%3A00%3A00&user_name=test&user_email=test%40karaaj.com
    if (this.form.from_date && this.form.to_date) {
      let form = this.form;
      this.$store.dispatch('affiliateWidget.getLocations', form).then(() => {
        this.sendMessageToParent('iframe_ready', {
          success: true,
          data: this.costs
        });
      });
      // this.getCost(true)
    }
    // Listen for messages from parent
    window.addEventListener('message', this.handleParentMessage)
    document.addEventListener('click', this.documentClicked);
    if (typeof document !== 'undefined') {
      document.documentElement.classList.add('affiliate-widget-embed')
      document.body.classList.add('affiliate-widget-embed')
    }
    // Report size to parent on load and whenever the widget layout changes
    this.$nextTick(() => {
      this._attachResizeObserver()
      this._scheduleAutoResize()
    })
  },
  beforeDestroy() {
    if (typeof document !== 'undefined') {
      document.documentElement.classList.remove('affiliate-widget-embed')
      if (document.body) {
        document.body.classList.remove('affiliate-widget-embed')
      }
    }
    if (this._resizeObserver) {
      this._resizeObserver.disconnect()
      this._resizeObserver = null
    }
    if (this._resizeRaf) {
      cancelAnimationFrame(this._resizeRaf)
      this._resizeRaf = null
    }
    // Clean up event listener
    window.removeEventListener('message', this.handleParentMessage)
  },
  unmounted () {
		document.removeEventListener('click', this.documentClicked);
	},
  watch: {
    locationLoading() {
      this.$nextTick(() => {
        this._attachResizeObserver()
        this._scheduleAutoResize()
      })
    },
    'reservationData.added'(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.showParkingDetails = false;
        this._carsDataSnapshotAtAdd = this.carsDataSemanticSnapshot(this.carsData)
        this.handleAddClick();
      }
      if (!newVal && oldVal) {
        this._carsDataSnapshotAtAdd = null
        this.sendMessageToParent('booking_deleted', {
          success: true,
          data: this.reservationData
        })
      }
    },

    form: {
      handler () {
        this.clearReservationAdded()
      },
      deep: true
    },

    addTripProtection(newVal) {
      if (newVal && this.protectionPlan && this.protectionPlan.id) {
        this.form.protection_plan_id = this.protectionPlan.id;
      } else {
        this.form.protection_plan_id = null;
      }
    },
    protectionPlans(newVal) {
      const plans = Array.isArray(newVal) ? newVal : []
      const selected = plans.find((plan) => Number(plan && plan.coverage_value) === 1000) || null
      this.protectionPlan = selected
      this.showProtectionPlans = !!selected
      if (!selected) {
        this.addTripProtection = false
        return
      }
      if (!this._protectionChoiceMade) {
        this._protectionChoiceMade = true
        this.addTripProtection = true
      } else if (this.addTripProtection) {
        this.form.protection_plan_id = selected.id
      }
    }
  },
    
  computed: {
    costs () {
      return this.$store.state.affiliateWidget.costs;
    },

    protectionPlans () {
      return this.$store.state.affiliateWidget.protectionPlans;
    },

    location () {
      const location = this.$store.state.affiliateWidget.location;
      if (location && location.extra_fields && _.isEmpty(this.form.extra_fields) && location.extra_fields.length > 0) {
        for (let i = 0; i < location.extra_fields.length; i++) {
          this.$set(this.form.extra_fields, location.extra_fields[i].name, [""]);
        }
      }
      if (location && location.reslab_id) {
        this.form.location_id = location.reslab_id;
      }
      return location;
    },

    parkingCancellationPolicies () {
      const policies = this.location && this.location.cancellation_policies
      if (!policies || !policies.length) {
        return null
      }

      const fullyRefundablePolicy = policies.find(
        policy => policy.type === 'parking' && Number(policy.percentage) === 100
      )

      if (!fullyRefundablePolicy) {
        return null
      }

      if (Number(fullyRefundablePolicy.number_of_days) === 0) {
        return { fullyRefundableUntillStart: true }
      }

      const fromDate = this.form && this.form.from_date
      if (fromDate && /\d{1,2}:\d{2}/.test(fromDate)) {
        const start = moment(fromDate, Object.values(DATE_FORMATS), true)

        if (start.isValid()) {
          const deadline = start.clone().subtract(fullyRefundablePolicy.number_of_days, 'days')

          if (deadline.isSameOrBefore(moment())) {
            return null
          }

          return {
            formattedDate: deadline.format(DATE_FORMATS.datetime_12).replace('12:00 AM', this.$t('midnight')),
          }
        }
      }

      return {
        formattedDate: null,
        fullyRefundabledays: fullyRefundablePolicy.number_of_days,
      }
    },

    coverPhoto () {
      if (!this.location || !this.location.cover_photo) {
        return null;
      }
    
      return this.location.cover_photo;
    },

    locationLoading (){
      return this.$store.state.affiliateWidget.loading;
    },

    isActionDisabled () {
      if (this.loading) return true;
      if (this.validationInFlight > 0) return true;
      if (this.confirmInProgress) return true;
      if (this.reservationData && this.reservationData.loading) return true;
      return false;
    },

    hasEmptyExtraFields () {
      if (!this.location || _.isEmpty(this.location.extra_fields)) return false;
      if (!this.form || !this.form.extra_fields) return true;

      return this.location.extra_fields.some((field) => {
        const values = this.form.extra_fields[field.name];
        if (!Array.isArray(values) || values.length === 0) return true;
        return values.some((value) => String(value == null ? '' : value).trim() === '');
      });
    },

    isConfirmDisabled () {
      return this.isActionDisabled || this.hasEmptyExtraFields;
    },

    errors () {
      return this.$store.state.affiliateWidget.errors;
    },

    amenities () {
      if (Array.isArray(this.location.amenities)) {
        const sortedAmenities = [...this.location.amenities].sort((a, b) => b.priority - a.priority);
        return sortedAmenities.slice(0, 2);
      }
      return [];    
    },

    reservationData() {
      return this.$store.state.affiliateWidget.reservationData;
    },

    addedStatePickupDisplay() {
      const portName = this.location && this.location.port && this.location.port.name
      const code = this.form && this.form.airport_code
      const parts = [portName, code].filter(Boolean)
      return parts.length ? parts.join(', ') : (code || '')
    },

    addedStateDestination() {
      if (!this.location) return ''
      return this.location.name || ''
    },

    addedReservationDateFormatted() {
      if (!this.form || !this.form.from_date) return ''
      const raw = this.form.from_date
      const formats = ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DDTHH:mm:ss.SSSZ', 'YYYY-MM-DD']
      let m = moment(raw, formats, true)
      if (!m.isValid()) m = moment(raw)
      return m.isValid() ? m.format('YYYY-MM-DD') : String(raw).split(' ')[0] || ''
    },

    numberOfDays() {
      if (this.costs && this.costs.reservation && this.costs.reservation.totals && this.costs.reservation.totals.parking && this.costs.reservation.totals.parking.number_of_days) {
        return this.costs.reservation.totals.parking.number_of_days;
      }
      return 0;
    },

    addedReservationTimeFormatted() {
      if (!this.form || !this.form.from_date) return ''
      const raw = this.form.from_date
      const formats = ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DDTHH:mm:ss.SSSZ', 'YYYY-MM-DD']
      let m = moment(raw, formats, true)
      if (!m.isValid()) m = moment(raw)
      return m.isValid() ? m.format('h:mma') : ''
    },

    formLevelError () {
      if (this.submitError) return this.submitError
      const keys = ['_form', 'reserved_by', 'reserved_for', 'user_email', 'user_name', 'costs_token', 'channel_id']
      for (let i = 0; i < keys.length; i++) {
        const message = this.reservationFieldMessage(keys[i])
        if (message) return message
      }
      return ''
    },

    totalPrice() {
      const reservation = this.costs && this.costs.reservation
      let total = reservation && reservation.grand_total != null ? Number(reservation.grand_total) : 0
      if (!Number.isFinite(total)) total = 0
      const includedPrice = reservation && reservation.protection_plan_price != null
        ? Number(reservation.protection_plan_price)
        : null
      const protectionIncluded = includedPrice != null && Number.isFinite(includedPrice) && includedPrice !== 0
      if (protectionIncluded) {
        if (!this.addTripProtection) total -= includedPrice
      } else if (this.addTripProtection && this.protectionPlan && this.protectionPlan.price != null) {
        const price = Number(this.protectionPlan.price)
        if (Number.isFinite(price)) total += price
      }
      return total
    },

    manageInfoPriceDisplay() {
      if (this.totalPrice == null || this.totalPrice === '') return ''
      const code = this.location && this.location.currency && this.location.currency.code
      const sym = currencySymbol(code)
      const n = Number(this.totalPrice)
      if (!Number.isFinite(n)) return `${sym}${this.totalPrice}`
      return `${sym}${n.toFixed(2)}`
    },
  }
}